<template>
  <div>
    <vx-card class="relative">
            <div v-if="!completed">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <!-- <vs-button @click="goBack" color="primary" type="border"
              >Back</vs-button
            > -->
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="9"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>{{campaignDescription.campaign_name}} Accounts</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="4"
            vs-xs="12"
          >
          
           
          </vs-col>
        </vs-row>
      </div>
      <template>
        <h3 class="text-dark-grey mb-16 text-center">
          We still have unmatched accounts. What would you like to do?
        </h3>
        <div class="vx-row mb-10">
          <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
            <router-link to="/accounts/add">
              <vx-card>
                <vs-row vs-w="12" class="">
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="10"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <feather-icon
                      icon="BookIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3"
                    />
                    <h5>Enter a new account int the master database?</h5>
                  </vs-col>
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                </vs-row>
              </vx-card>
            </router-link>
          </div>

          <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
            <router-link :to="export_link">
              <vx-card>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="10"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <feather-icon
                      icon="MapIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3"
                    />
                    <h5>Export unmatched records from the CSV table?</h5>
                  </vs-col>
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                </vs-row>
              </vx-card>
            </router-link>
          </div>
          <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
            <router-link to="/dashboard">
              <vx-card>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="10"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <feather-icon
                      icon="FigmaIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3"
                    />
                    <h5>Nothing, I will come back to this later</h5>
                  </vs-col>
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                </vs-row>
              </vx-card>
            </router-link>
          </div>
        </div>
         <div class="vx-row mb-10">
          <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
            <router-link :to="enrich_account_to_master_db_link">
              <vx-card>
                <vs-row vs-w="12" class="">
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="10"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <feather-icon
                      icon="BookIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3"
                    />
                    <h5>Update matched account data to master database.</h5>
                  </vs-col>
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                </vs-row>
              </vx-card>
            </router-link>
          </div>

          <!-- <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
            <router-link :to="enrich_account_field_data_to_master_db_link">
              <vx-card>
                <vs-row vs-w="12" class="">
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="10"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <feather-icon
                      icon="BookIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3"
                    />
                    <h5>Enrich matched account field data to master database.</h5>
                  </vs-col>
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                </vs-row>
              </vx-card>
            </router-link>
          </div> -->

       
       
        </div>
      </template>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import axios from "@/axios.js";
export default {
  data() {
    return {
      campaignDescription:[],
      export_link:null,
      enrich_account_to_master_db_link:null,
      enrich_account_field_data_to_master_db_link:null,
      abilities : null,
      campaignId:null,
      completed: false,

    };
  },
  mounted() {
        this.getCampaignDescription()
    this.export_link = '/accounts/remain_unmatched/' + this.campaignId
    this.enrich_account_to_master_db_link = '/accounts/enrichAccountDataToMasterDb/' + this.campaignId
    this.enrich_account_field_data_to_master_db_link = '/accounts/enrichAccountFieldDataToMasterDb/' + this.campaignId

  },
  watch: {
    
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
            getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
  },
  created(){
    var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });  
     if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;
    console.log(this.campaignId)
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.searchbox {
  padding: 10px 21px;
  width: 600px;
}

.relative {
  /* position: fixed !important; */
  z-index: 999;
  /* width: 98.5%; */
}

.vxtable {
  /* position: absolute !important; */
  margin-top: 20px;
}
</style>
